// Angular
import { Component, OnInit, Input } from '@angular/core';

// Data/Class/Interface/Others
import { TransactionsIFace } from 'src/app/shared/classes';
import { MessagesService } from 'src/app/services/message/messages.service';
import { environment } from '../../../../../environments/environment.prod'


@Component({
  selector: 'app-transaction-show',
  templateUrl: './transaction-show.component.html',
  styleUrls: ['./transaction-show.component.less']
})
export class TransactionShowComponent implements OnInit {
  @Input() transaction: TransactionsIFace ;

  public transactionInfo = {
    orderid: '',
    item: '',
    price: '',
    paytype: '',
    date: '',
    name: '',
    email: '',
    address:'',
    phone:'',
    plan_type:''
  };

  constructor(private msg: MessagesService) { }

  ngOnInit() {
    this.setData();
  }

  private setData() {
    this.transactionInfo.orderid = this.transaction.data.orderid;
    this.transactionInfo.price = this.transaction.data.price;
    this.transactionInfo.paytype = this.transaction.data.payType;
    this.transactionInfo.date = this.transaction.data.date;
    this.transactionInfo.name = this.transaction.data.name;
    this.transactionInfo.email = this.transaction.data.email;
    this.transactionInfo.item = this.transaction.data.item;
    this.transactionInfo.address = this.transaction.data.address;
    this.transactionInfo.plan_type = this.transaction.data.plan_type;
    this.transactionInfo.phone = this.transaction.data.phone;
  }

  generatePDF(){
    const baseUrl = environment.favoriotPaymentUrl2+"receipt";
    const url = `${baseUrl}?user_id=${this.transaction.data['user_id']}&order_id=${this.transaction.data['orderid']}`;

    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = '_blank';
    anchor.download = `receipt_${this.transaction.data['user_id']}_${this.transaction.data['orderid']}.pdf`;
    anchor.click();
   }

  copyInputMessage(inputElement){
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.msg.success("Copied");
  }
}
